var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbmasonProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdc4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24184,
    stopColor: "#f57269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#950609"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.14214 55.82094 53.14024 55.82094 52.593 56.76948 53.14024 61.76758 54.23471 56.69652 53.79692 55.82094 58.13833 55.82094 57.73703 56.69652 58.53964 61.58517 59.26929 56.733 58.68557 55.82094 63.31884 55.82094 62.47975 56.55059 61.09341 67.64125 61.82306 68.69925 56.20476 68.69925 56.752 67.64125 55.73049 63.15391 55.2927 67.56829 55.73049 68.69925 50.22164 68.69925 50.95129 67.78718 49.01772 57.13431 48.14214 55.82094"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 64.04688,
    cy: 66.4814,
    rx: 1.75566,
    ry: 1.96687
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.81543,64.91339l-.09561-1.72972c-.06642-1.20163-.95589-2.19718-2.14249-2.39799l.10616-.10385c.83067-.81261,1.20003-1.98675.98421-3.12859-.34722-1.83684-2.08571-3.06958-3.93398-2.78956l-5.95879.90285.71792.8428,1.40464,10.61282-.68671,1.32611,7.32341-.83291c1.35607-.15422,2.35657-1.33925,2.28125-2.70198ZM69.05522,57.90208l1.34823-.13537c.60499-.06074,1.14467.38046,1.20543.98547.06074.60499-.38046,1.14467-.98547,1.20543l-1.34823.13536-.21996-2.19088ZM71.38553,65.10568l-1.34823.13536-.21998-2.19088,1.34823-.13536c.605-.06076,1.14469.38045,1.20543.98545s-.38046,1.14469-.98545,1.20543Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.86392,33.57586l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.1849,41.82896l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.09161,51.81206l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbmasonProductsScraper);
export default __webpack_public_path__ + "static/media/wbmason-products-scraper.495e60ef0d3f6dbfeae043b7ca5536ba.svg";
export { ForwardRef as ReactComponent };